<template>
  <div id="drop_header" :class="`header ${smaler ? 'smaller' : ''}`">
    <template>
      <img
        :src="`https://space.monresto.menu/logos/${restaurant.logo}`"
        alt=""
        class="logo_drop"
      />
      <h1
        class=""
        v-text="newItem[currentLang] ? newItem[currentLang].name : ''"
      >
        {{ name }}
      </h1>
      <p class="description ">
        Tous nos plats sont "Faits maison" et élaborés sur place à partir de
        produits bruts et peuvent demander un certain temps de réalisation
      </p>
    </template>
  </div>
</template>

<script>
export default {
  props: ["restaurant", "smaler", "changeName", "currentLang", "newItem"],
  data() {
    return {
      name: "name of the menu",
    };
  },
  watch: {
    name(newVal) {
      this.changeName(newVal);
    },
  },
};
</script>

<style>
#drop_header.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
  padding-top: 40px;
  background-color: #fff;
  width: 100%;
  flex: 1;
}
#drop_header.header.smaller {
  padding-top: 10px;
}

#drop_header.logo_drop {
  /* width: 100%; */
  width: 20%;
  /* height: 100px; */
  /* border-radius: 50%; */
  margin-bottom: 30px;
  object-fit: contain;
  /* 
    -webkit-box-shadow: -1px 12px 21px -3px rgba(199, 193, 199, 1);
    -moz-box-shadow: -1px 12px 21px -3px rgba(199, 193, 199, 1);
    box-shadow: -1px 12px 21px -3px rgba(199, 193, 199, 1); */
}
#drop_header h1 {
  font-size: 2rem;
  text-align: center;
}
#drop_header p.description {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}
#drop_header .logo_drop.smaller {
  margin-bottom: 10px;
}
#drop_header p.smaller {
  font-size: 8px;
  margin-top: 0px;
  margin-bottom: 0px;
}
#drop_header h1.smaller {
  font-size: 12px;
}

@media screen and (max-width: 580px) {
  .logo_drop {
    width: 150px;
  }
  #drop_header h1 {
    font-size: 1.3rem;
    margin-top: 1.4em;
  }
  .dorpdown_theme.items {
    padding-top: 0 !important ;
  }
  #drop_header p.description {
    margin-bottom: 2px !important;
  }
}
</style>
